import React, { useState, FC } from "react";
import Icon from "components/icon";
import ProfileIcon from "components/layout/profileIcon";
import { Navbar, NavbarBrand, Collapse, NavbarToggler, Nav } from "reactstrap";
import { Link } from "react-router-dom";
import "./header.scss";

const Header: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar className="navbar-header" dark expand="md">
      <div className="container">
        <NavbarBrand to="/" tag={Link}>
          <Icon name="sasr" />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            {/*<NavItem>
              <NavLink href="#" className="secondary-link">
                What's New?
              </NavLink>
            </NavItem>*/}
          </Nav>
          <ProfileIcon className="ml-auto" />
        </Collapse>
      </div>
    </Navbar>
  );
};

export default Header;
